export default __webpack_public_path__ + "static/media/shoefi.aaf2ded9.png";